import type { StudentApplication } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useStudentApplicationList } = getCRUDHooks<StudentApplication>({
  entityName: 'studentApplicationList',
  find: ({ filters }) =>
    clientApi.getOCClient().helpers.studentApplication.studentApplication.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentApplicationList };
